import * as types from './detail-mutation-types'

export default {
  state: {
    item: {},
    detailCurrentSkuInfo: {},
    detailTabIndex: 0,
    itemStatus:{
      isOpenShoppe: false, // 是否开通专柜
      scrollOverDetail: false, // 滑动是否已经超过了 商品图文
      showActivtiesDialog: false, // 云集承诺弹窗
      showCrossDialog: false, // 跨境说明弹窗
      showPromiseDialog: false, // 买赠弹窗
    },
    buyActivtiesInfo:{
      ShowFlag: false, //是否显示购买活动的标志
      giftData: {}, //买赠数据
      fullminusData: {}, //满立减活动数据
      blacklistData: {},  //优惠券黑名单数据
      feedBackMarksData: {}, // 下单返券数据
      mergeMarkBo: {}//N元X件任选数据
    },
    shoppeInfo:{},
    colorCountDownStyle:'default', //商详-特卖行主题样式
    colorBottomBtnStyle:'default' //商详-底部按钮主题样式
  },
  mutations: {
    [types.SET_ITEM](state, payload) {
      state.item = payload.item;
    },
    [types.DETAIL_CURRENT_SKU_INFO](state, payload) {
      state.detailCurrentSkuInfo = payload.detailCurrentSkuInfo;
    },
    [types.DETAIL_TAB_INDEX](state, payload) {
      state.detailTabIndex = payload.detailTabIndex;
    },
    [types.DETAIL_SET_ISOPEN_SHOPPE](state, payload) {
      state.itemStatus.isOpenShoppe = payload.isOpenShoppe;
    },
    [types.DETAIL_SET_SCROLL_OVER_DESC](state, payload) {
      state.itemStatus.scrollOverDetail = payload.scrollOverDetail;
    },
    [types.DETAIL_SET_SHOW_ACTIVTIES_DIALOG](state, payload) {
      state.itemStatus.showActivtiesDialog = payload.showActivtiesDialog;
      state.buyActivtiesInfo = payload.buyActivtiesInfo;
    },
    [types.DETAIL_SET_SHOW_CROSS_DIALOG](state, payload) {
      state.itemStatus.showCrossDialog = payload.showCrossDialog;
    },
    [types.DETAIL_SET_SHOW_PROMISE_DIALOG](state, payload) {
      state.itemStatus.showPromiseDialog = payload.showPromiseDialog;
    },
    [types.DETAIL_SET_SHOPPE_INFO](state, payload) {
      state.shoppeInfo = payload.shoppeInfo;
    },
    [types.DETAIL_SET_COLOR_COUNTDOWN_STYLE](state, payload) {
      state.colorCountDownStyle = payload.colorCountDownStyle;
    },
    [types.DETAIL_SET_COLOR_BOTTOMBTN_STYLE](state, payload) {
      state.colorBottomBtnStyle = payload.colorBottomBtnStyle;
    },
    [types.DETAIL_RESET](state, payload) {
      state.itemStatus.showPromiseDialog = payload.showPromiseDialog;
      state.item = {};
      state.detailCurrentSkuInfo = {};
      state.detailTabIndex = 0;
      state.itemStatus = {
        isOpenShoppe: false, // 是否开通专柜
        scrollOverDetail: false, // 滑动是否已经超过了 商品图文
        showActivtiesDialog: false, // 云集承诺弹窗
        showCrossDialog: false, // 跨境说明弹窗
        showPromiseDialog: false, // 买赠弹窗
      };
      state.buyActivtiesInfo = {
        ShowFlag: false, //是否显示购买活动的标志
        giftData: {}, //买赠数据
        fullminusData: {}, //满立减活动数据
        blacklistData: {},  //优惠券黑名单数据
        feedBackMarksData: {}, // 下单返券数据
        mergeMarkBo: {}//N元X件任选数据
      };
      state.shoppeInfo = {};
      state.colorCountDownStyle = 'default';
      state.colorBottomBtnStyle = 'default';
    },
  },
  actions: {},
  getters: {},
};
